/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Pain_RegionInputs */

const en_us2_workout_after_pain_region = /** @type {(inputs: Workout_After_Pain_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where did it hurt?`)
};

const pt_br2_workout_after_pain_region = /** @type {(inputs: Workout_After_Pain_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onde doeu?`)
};

const es_419_workout_after_pain_region = /** @type {(inputs: Workout_After_Pain_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Dónde te dolió?`)
};

const pt_pt2_workout_after_pain_region = /** @type {(inputs: Workout_After_Pain_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onde doeu?`)
};

const fr_fr2_workout_after_pain_region = /** @type {(inputs: Workout_After_Pain_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Où avais-tu mal ?`)
};

const de_de2_workout_after_pain_region = /** @type {(inputs: Workout_After_Pain_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wo hat es wehgetan?`)
};

const it_it2_workout_after_pain_region = /** @type {(inputs: Workout_After_Pain_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dove ha fatto male?`)
};

/**
* | output |
* | --- |
* | "Where did it hurt?" |
*
* @param {Workout_After_Pain_RegionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_pain_region = /** @type {((inputs?: Workout_After_Pain_RegionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Pain_RegionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_pain_region(inputs)
	if (locale === "es-419") return es_419_workout_after_pain_region(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_pain_region(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_pain_region(inputs)
	if (locale === "de-DE") return de_de2_workout_after_pain_region(inputs)
	if (locale === "it-IT") return it_it2_workout_after_pain_region(inputs)
	return en_us2_workout_after_pain_region(inputs)
});
export { workout_after_pain_region as "workout-after.pain_region" }